import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Sparkles } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center pt-20 pb-16 overflow-hidden" data-id="element-126">
      {/* Background glow effects */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-brand-cyan/20 rounded-full blur-[120px] -z-10" data-id="element-127" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-brand-purple/20 rounded-full blur-[120px] -z-10" data-id="element-128" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-129">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-130">
          <motion.div className="flex flex-col gap-8" initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-131">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass-card border-brand-cyan/30 text-brand-cyan w-fit text-sm font-medium" data-id="element-132">
              <Sparkles size={16} data-id="element-133" />
              <span data-id="element-134">El Sistema Definitivo de Creación de Contenido</span>
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold leading-tight tracking-tight text-center" data-id="element-135">
              INSTA-BRAND{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-cyan to-brand-purple text-glow-cyan" data-id="element-136">
                AI
              </span>
              <span className="block text-3xl md:text-4xl mt-4 text-white/90 font-medium" data-id="element-137">
                El Sistema "Ghost" para Dominar Redes en la Era de la
                Inteligencia Artificial
              </span>
            </h1>

            <p className="text-xl md:text-2xl text-brand-gray font-light leading-relaxed" data-id="element-138">
              Lanza una marca personal viral y factura con IA sin mostrar tu
              rostro, sin equipo de producción y sin miedo a la cámara.
            </p>

            <div className="pt-4" data-id="element-139">
              <Button href="#pricing-card" className="w-full sm:w-auto text-lg py-5 px-10" data-id="element-140">
                ¡QUIERO EMPEZAR MI MARCA GHOST AHORA!
              </Button>
            </div>
          </motion.div>

          <motion.div className="relative lg:h-[600px] flex justify-center items-center" initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2
        }} data-id="element-141">
            <div className="absolute inset-0 bg-gradient-to-tr from-brand-cyan/20 to-brand-purple/20 rounded-3xl blur-3xl -z-10" data-id="element-142" />
            <img src="https://cdn.magicpatterns.com/uploads/rzTVAjDyVkYsHz3fiBSB84/INSTA_-_BRAND_AI_COVER.png" alt="Insta-Brand AI Cover" className="w-full max-w-md object-contain animate-float drop-shadow-[0_0_30px_rgba(0,240,255,0.3)]" data-id="element-143" />
          </motion.div>
        </div>

        <motion.div className="mt-24 max-w-4xl mx-auto text-center glass-card p-8 md:p-12 rounded-2xl border-brand-purple/30 relative overflow-hidden" initial={{
        opacity: 0,
        y: 50
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} data-id="element-144">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-purple to-transparent" data-id="element-145" />
          <p className="text-lg md:text-xl text-white/90 leading-relaxed italic" data-id="element-146">
            "¿Alguna vez has sentido que estás perdiendo una oportunidad
            histórica con la Inteligencia Artificial mientras otros influencers
            'sin rostro' acumulan millones de vistas y ventas? Mirar desde
            afuera cómo otros monetizan el contenido digital mientras tú te
            quedas paralizado por no querer exponerte ante la cámara es
            frustrante. La buena noticia es que ya no necesitas ser el
            protagonista para ser el dueño del negocio."
          </p>
        </motion.div>
      </div>
    </section>;
}